import { cn } from '@/lib/utils';
import {
  ClientBillVm,
  BillRowVm,
} from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import { Card } from '@/components/ui/Card.tsx';
import { SectionColumnHeader } from '@/features/dashboard/bookingChanges/components/primitives';
import CrossLinkRow, { BookingCodeLink } from './CrossLinkRow';
import BillSectionList from './BillSectionList';

interface ClientBillViewProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ClientBillVm;
  isEditing: boolean;
  onRowAction: (row: BillRowVm) => void;
  onOpenBooking: () => void;
  bookingCode: string;
  /**
   * Widok wpuszczony w kafel osoby — karta gubi ramkę, promień i cień, bo
   * obudowuje ją już kafel.
   */
  embedded?: boolean;
}

/**
 * Ekran osoby zapisującej (B1/B2) — ten sam układ sekcji co u uczestnika, ale
 * bez kolumny kwot: zapisujący nie ma własnego rachunku, saldo i raty stoją po
 * stronie rezerwacji. Filtra „Tylko zmienione" też nie ma, bo cały zestaw
 * kontaktowy zapisuje się jako jedna pozycja paczki.
 */
const ClientBillView = ({
  data,
  isEditing,
  onRowAction,
  onOpenBooking,
  bookingCode,
  embedded = false,
  className,
  ...props
}: ClientBillViewProps) => (
  <Card
    highlighted={isEditing}
    className={cn(
      'overflow-hidden',
      embedded && 'rounded-none border-0 shadow-none',
      className,
    )}
    {...props}
  >
    <div className="px-4 pt-0.5 sm:px-7">
      <SectionColumnHeader />

      <BillSectionList
        className="pb-0.5"
        sections={data.sections}
        isEditing={isEditing}
        onRowAction={onRowAction}
      />
    </div>

    <CrossLinkRow
      className="mt-[22px] border-t border-neutral-100 px-4 pb-6 pt-5 sm:px-7"
      actionLabel="Otwórz rezerwację →"
      onAction={onOpenBooking}
    >
      Płatnik rezerwacji{' '}
      <BookingCodeLink bookingCode={bookingCode} onClick={onOpenBooking} /> ·
      saldo i raty po stronie rezerwacji
    </CrossLinkRow>
  </Card>
);

export default ClientBillView;
